var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.5,
    height: 9.5,
    viewBox: "0 0 9.5 9.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54225",
    "data-name": "Path 54225",
    d: "M9.032,0H.468A.465.465,0,0,0,0,.46V2.192a.452.452,0,0,0,.128.316l3.3,3.428v3.1a.46.46,0,0,0,.283.422.478.478,0,0,0,.186.038.469.469,0,0,0,.327-.132L5.934,7.715a.458.458,0,0,0,.141-.328V5.945l3.3-3.437A.455.455,0,0,0,9.5,2.192V.46A.465.465,0,0,0,9.032,0ZM8.906.594V1.6H.594V.594Zm-3.3,4.981a.455.455,0,0,0-.126.315V7.327L4.019,8.738V5.879a.455.455,0,0,0-.128-.316L.654,2.2H8.846Z",
    transform: "translate(-8 -8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.54249e3520fdae9f5ef06c4d98081b2d.svg";
export { ForwardRef as ReactComponent };